import { useState, useEffect } from "react"

import { AppState } from "../../../state/store"
import { getLeadRequest } from "./request"

export type LeadRequestData = {
  ActionType: string
  VehicleType: string
  DealershipName: string
  DealershipGuid: string
  Customer: {
    FirstName: string
    LastName: string
    Email: string
    Mobile?: string
    Landline?: string
    Postcode: string
  }
  Vehicle: {
    Registration: string
    manufacturer: string
    model: string
  }
}

type FailedLeadPage = {
  history: {
    push: Function;
  };
};

export const useGetLead = (
  addLead: Function,
) => {
  const vehicleNotFound = '/valuation-request-not-processed';

  const [requestData, setRequestData] = useState<LeadRequestData | null>(null)
  const [failedLeadPage, setFailedLeadPage] = useState<FailedLeadPage | null>(null);

  useEffect(() => {
    if (requestData) {
      getLeadRequest(requestData)
        .then((data) => {
          addLead(data)
        })
        .catch(() => {
          if (failedLeadPage && failedLeadPage.history.push) {
            failedLeadPage.history.push(`${vehicleNotFound}`);
          }
        });
    }
    // eslint-disable-next-line
  }, [requestData, failedLeadPage])

  return ({
    registration,
    whichVehicle: { model, brand },
    whichVehicleType,
    contactDetails: { firstName, lastName, email, contactNumber, postcode, countryCode },
    appointmentDetails: { dealership },
    dealershipGuid,
  }: AppState, history: any) => {
    const isUkMobile = countryCode === "+44" && /^((07[0-9]{9}))$/.test(contactNumber)
    const isIrishMobile = countryCode === "+353" && /^((08[0-9]{6,13}))$/.test(contactNumber)
    const customerData = {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      Mobile: (isUkMobile || isIrishMobile ? contactNumber : ""),
      Landline: (!isUkMobile && !isIrishMobile ? contactNumber : ""),
      Postcode: postcode,
    }

    setRequestData({
      ActionType: "Valuation",
      VehicleType: whichVehicleType,
      DealershipName: dealership,
      DealershipGuid: dealershipGuid,
      Customer: customerData,
      Vehicle: {
        Registration: registration,
        manufacturer: brand,
        model: model,
      },
    })

    setFailedLeadPage({ history });
  }
}
